export default __webpack_public_path__ + "static/Principle-scale-a4610b0df46691dcb648c3f84bb0486e.png";